import ShortenedTitle from "components/General-UI/ShortenedTitle";
import React from "react";

const EfficeTitle = ({ title }) => {
  // needs to take in the messages sent and shorten them (and add ...) to fit in da url
  return (
    <div className={`effice-title`}>
      <ShortenedTitle title={title} maxChars={40} />
    </div>
  );
};

export default EfficeTitle;
